import "./styles.css";
import React, { useEffect, useState } from "react";
// import Select from 'react-select';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
const CountryPicker = (props) => {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({});

  useEffect(() => {
    fetch(
      "https://valid.layercode.workers.dev/list/countries?format=select&flags=true&value=name"
    )
      .then((response) => response.json())
      .then((data) => {
        setCountries(data.countries);
        setSelectedCountry(data.userSelectValue);
      });
  }, []);
  return (
    <Select
      value={selectedCountry}
     {...props}
    >
         {countries.filter(e=> e.value != "Israel" && e.value !="Italy").map((e) => (!props?.withLabel ? 
                            <MenuItem value={e.value}>{e.label}</MenuItem>: <MenuItem value={e.value}/>
                        ))}
    </Select>
  );
};

export default CountryPicker;